import { EPostStatus } from '@constants';
import { IDate, IPost } from '@sdk/contracts';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { ScheduledInfo } from '../../PostForm.styles';

import { Icon } from '@/components/Icon';
import { formatScheduledDate } from '@/utils';

type Props = {
  post?: IPost;
  formScheduledDate?: IDate;
  onEdit: () => void;
};

const ICON_SIZE = 16;

export const ScheduledDateDisplay: React.FC<Props> = ({ post, formScheduledDate, onEdit }) => {
  const { t } = useTranslation('CommonDashboardTranslations');
  const { t: tDefault } = useTranslation('DefaultTranslations');

  const isScheduledPost = post?.status === EPostStatus.SCHEDULED;
  const scheduledDate = formScheduledDate || post?.scheduledPublishDate;

  if (!isScheduledPost || !scheduledDate) {
    return null;
  }

  return (
    <ScheduledInfo>
      <Icon i="EarthEuropeAfrica" size={ICON_SIZE} />
      <Typography.Text>
        {t('SCHEDULED_AT', {
          date: formatScheduledDate(new Date(scheduledDate.dateTime), tDefault)
        })}
      </Typography.Text>
      <Button type="link" onClick={onEdit}>
        {t('EDIT')}
      </Button>
    </ScheduledInfo>
  );
};
